import labelsMixin from '../../mixins/labels.js';

var script = {
  name: 'PendoCheckboxGroup',
  mixins: [labelsMixin],
  inject: {
    $formItem: {
      default: ''
    }
  },
  provide() {
    return {
      $checkboxGroup: this
    };
  },
  props: {
    value: {
      type: null,
      default: null
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: direction => ['vertical', 'horizontal'].includes(direction)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ariaLabelledBy() {
      if (this.$formItem) {
        return this.$formItem.labelId;
      }
      if (this.topLabel) {
        return `pendo-checkbox-group__label--top-${this._uid}`;
      }
      if (this.bottomLabel) {
        return `pendo-checkbox-group__label--bottom-${this._uid}`;
      }
      return undefined;
    }
  },
  watch: {
    value(value) {
      if (this.$formItem) {
        this.$formItem.onFieldChange(value);
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-checkbox-group.vue2.js.map
